<template>
  <div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <div class="table-operator">
                <a-button type="primary" icon="plus" @click="handleCreate">添加</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        ref="table"
        size="small"
        rowKey="id"
        :loading="loading"
        :columns="columns"
        :data="loadData"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <div slot="is_enable" slot-scope="text, record">
          <a-switch @change="handleUsed(record)" :checked="text"/>
        </div>
        <div slot="money_render" slot-scope="text">
          {{ (text / 100).toFixed(2) | numberFormat }}
        </div>
        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="groupGoods(record)">关联商品</a>
            <a-divider type="vertical"/>
            <a-popconfirm
              title="确定要删除么？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(record)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
    </a-card>
    <create-discount-form
      ref="createModal"
      v-if="visible"
      :visible.sync="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { createGroupDiscount, putGroupDiscount, groupDiscountList, deleteGroupDiscount } from '@/api/applet_shop_group_discount'
import CreateDiscountForm from './CreateDiscountForm'
import moment from 'moment'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateDiscountForm
  },
  data () {
    return {
      loading: false,
      visible: false,
      confirmLoading: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: '50px',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '折扣名称',
          ellipsis: true,
          dataIndex: 'name'
        },
        {
          title: '数量',
          ellipsis: true,
          dataIndex: 'count'
        },
        {
          title: '总价',
          ellipsis: true,
          dataIndex: 'price',
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '开始时间',
          ellipsis: true,
          dataIndex: 'start_date'
        },
        {
          title: '结束时间',
          ellipsis: true,
          dataIndex: 'end_date'
        },
        {
          title: '启用',
          ellipsis: true,
          dataIndex: 'is_enable',
          scopedSlots: { customRender: 'is_enable' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return groupDiscountList(Object.assign(parameter, this.queryParam))
          .then(({ data }) => {
            return data
          })
      }
    }
  },
  methods: {
    handleCreate () {
      this.mdl = null
      this.visible = true
      this.confirmLoading = false
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk () {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          this.confirmLoading = true
          values.price = Math.round(values.price * 100)
          values.start_date = moment(values.start_date).format('YYYY-MM-DD')
          values.end_date = moment(values.end_date).format('YYYY-MM-DD')
          if (this.mdl && this.mdl.id) {
            putGroupDiscount(values, this.mdl.id).then((res) => {
              this.visible = false
              this.confirmLoading = false
              this.$refs.table.refresh()
            }).catch(errors => {
              values.price = (values.price / 100).toFixed(2)
            }).finally(() => {
              this.confirmLoading = false
            })
          } else {
            console.log('提交的数据----', values)
            createGroupDiscount(values).then((res) => {
              this.visible = false
              this.confirmLoading = false
              this.$refs.table.refresh()
            }).catch(errors => {
              values.price = (values.price / 100).toFixed(2)
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleDelete (item) {
      console.log(item)
      deleteGroupDiscount(item.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleUsed (item) {
      this.loading = true
      putGroupDiscount({ is_enable: !item.is_enable }, item.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    groupGoods (item) {
      console.log(item)
      this.$router.push({
        path: '/commonshop/group_discount_goods',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>
